import { Tabs as Component } from './styled';

export const Tabs = Component;
